import {createSlice} from "@reduxjs/toolkit"
import axios from '../../../utils/axios';
import {
  getPickupTimeDataFromSessionStorage,
  setPickupTimeDataToSesstionStorage,
  setSuggestedPickupTimeToSessionStorage,
  getSuggestedPickupTimeFromSessionStorage,
  getOrderPayloadFromSessionStorage
} from '../../../actions/nxt-local-storage';

export const fetchPickupTimeRange= () => async (dispatch,getState) => {
 
  let data = getState().appState.session.data.branch
    const pickupTimeUrlUrl = `/take-out/companies/${data.companyId}/branches/${data.id}/pickup-times`;

    var response = null;
    try {
      response = await axios.get(pickupTimeUrlUrl);
    } catch (error) {
      response = error.response || error;
    }
  
    if (response && response.data) {
      if (response.data.success) {
          dispatch(getPickTimeRange(response.data.data))
      }
      else{
        dispatch(setPickupTimeRangeError(response));
      }
    } else {
      // network error
      dispatch(setPickupTimeRangeError(response));
    }
  };

  export const reFetchPickupTimeRange= () => async (dispatch,getState) => {
   
    let body =getOrderPayloadFromSessionStorage()?.orderMenus
    let data = getState().appState.session.data.branch
      const pickupTimeUrlUrl = `/take-out/companies/${data.companyId}/branches/${data.id}/recommended-pickup-times`;
  
      var response = null;
      try {
        response = await axios.post(pickupTimeUrlUrl,body);
      } catch (error) {
        response = error.response || error;
      }
    
      if (response && response.data) {
        if (response.data.success) {
            dispatch(getPickTimeRange(response.data.data))
        }
        else{
          dispatch(setPickupTimeRangeError(response));
        }
      } else {
        // network error
        dispatch(setPickupTimeRangeError(response));
      }
    };
  


export const pickuptimeSlice = createSlice({
    name:"pickupTime",
    initialState:{
        pickTimeSelect:"",
        pickupTimeRange:{
            data:[],
            error:null
        },
        suggestedPickupTime:getSuggestedPickupTimeFromSessionStorage()?getSuggestedPickupTimeFromSessionStorage():false
    },
    reducers:{
        getPickTimeRange:(state,{payload})=>{
           state.pickupTimeRange.data=[...payload]
        },
        selectPickupTime:(state,{payload})=>{
            state.pickTimeSelect=payload
            setPickupTimeDataToSesstionStorage(payload)
        },
        setPickupTimeRangeError:(state,{payload})=>{
            state.pickupTimeRange.error=payload
        },
        setSuggestedPickupTime:(state,{payload})=>{
          state.suggestedPickupTime=payload
          setSuggestedPickupTimeToSessionStorage(payload)
        },
    }
})

export const {getPickTimeRange,selectPickupTime,setPickupTimeRangeError,setSuggestedPickupTime} =pickuptimeSlice.actions;

export default pickuptimeSlice.reducer;